import { useMemo } from 'react'
import { EventType } from 'types/Event'

interface UseFilteredEventsProps {
    data: EventType[]
    selectedDate: Date
    selectedLocation: string | null
}

export const useFilteredEvents = ({ data, selectedDate, selectedLocation }: UseFilteredEventsProps) => {
    const filteredEventsByDate = useMemo(() => {
        return data.filter((event) => {
            const eventDate = new Date(event.event_date)
            return (
                eventDate.toLocaleDateString('hu-HU', { year: 'numeric', month: '2-digit' }) ===
                selectedDate.toLocaleDateString('hu-HU', { year: 'numeric', month: '2-digit' })
            )
        })
    }, [data, selectedDate])

    const availableLocations = useMemo(() => {
        const locations = new Set(filteredEventsByDate.map((event) => event.location_id))
        return Array.from(locations)
    }, [filteredEventsByDate])

    const filteredEvents = useMemo(() => {
        return filteredEventsByDate
            .filter((event) => {
                return selectedLocation ? event.location_id === selectedLocation : true
            })
            .sort((a, b) => new Date(a.event_date).getTime() - new Date(b.event_date).getTime())
    }, [filteredEventsByDate, selectedLocation])

    return {
        filteredEvents,
        availableLocations,
    }
}
